<ng-template #redployModalFormContent role="document" let-modal>

  @if(!embeddedFormMode) {
    <app-modal-comp-header
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm(); modal.dismiss('Cross click')"
    ></app-modal-comp-header>
  }

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form [formGroup]="redeployForm" class="tablelist-form" autocomplete="off" name="no-autofill-form">
      <div class="modal-body">

        <!-- <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                <span [innerHtml]="progressInformation"></span>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="activationTypeId-field" class="form-label text-right">Activation Method</label>
              <div class="input-group">
                <select
                  autocomplete="off"
                  class="form-select"
                  name="activationTypeId-field"
                  id="activationTypeId-field"
                  formControlName="activationTypeId"
                  (change)="activationTypeSelectDropDownChange($event)"
                  [ngClass]="{ 'is-invalid': formSubmitted && formData['activationTypeId'].errors }"
                >
                  <option selected></option>
                  <option value="1">Direct Push via EID</option>    
                  <option value="2">Send via SMS/email</option>  
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
        </div>

        @if(selectedActivationTypeId == DeviceActivationTypePushViaSMSEmail) {
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="deviceOSTypeId-field" class="form-label text-right">Device OS</label>
                <div class="input-group">
                  <select
                    autocomplete="off"
                    class="form-select"
                    name="deviceOSTypeId-field"
                    id="deviceOSTypeId-field"
                    formControlName="deviceOSTypeId"
                    (change)="deviceOSTypeSelectDropDownChange($event)"
                    [ngClass]="{ 'is-invalid': formSubmitted && formData['deviceOSTypeId'].errors }"
                  >
                    <option selected></option>
                    <option value="1">Apple iOS</option>    
                    <option value="2">Android</option>  
                    <option value="3">Windows</option>  
                  </select>
                  <div class="invalid-feedback">A value is required</div>
                </div>
              </div>
            </div>
          </div>
        } -->

        <div class="labeled-divider mb-3 mt-3 ml-20 mr-20">
           <span class="divider-label">Delivery Method</span>
        </div>
        <div class="delivery-grid ml-20 mr-20" [style.grid-template-columns]="'repeat(' + filteredDeliveryMethods.length + ', 1fr)'">
          <button
            *ngFor="let m of filteredDeliveryMethods"
            class="delivery-button"
            [ngClass]="{
              'selected': deliveryMethod === m.id
            }"
            (click)="selectMethod(m.id)"
          >
            <div class="icon">{{ m.icon }}</div>
        
            <div class="label" [ngClass]="{ 'label-selected': deliveryMethod === m.id }">
              {{ m.label }}
            </div>
        
            <div class="desc">
              {{ m.desc }}
            </div>
          </button>
        </div>
<!-- Device Type -->
        @if(deliveryMethod === 'sms' || deliveryMethod === 'email') {
          <div class="labeled-divider mb-3 mt-3 ml-20 mr-20">
            <span class="divider-label">Device Type</span>
          </div>
          <div [ngClass]="{ 'device-grid-3-columns' : deliveryMethod === 'email', 'device-grid-2-columns ml-20 mr-20' : deliveryMethod === 'sms'}">
            @for (d of filteredDeviceTypes; track d.id) {
              <button
                class="device-btn"
                [ngClass]="{ selected: deviceType === d.id }"
                (click)="setDeviceType(d.id)"
              >
                <div class="icon">{{ d.icon }}</div>

                <div
                  class="device-label"
                  [ngClass]="{ 'label-selected': deviceType === d.id }"
                >
                  {{ d.label }}
                </div>

                <div class="device-desc">
                  {{ d.desc }}
                </div>
              </button>
            }
          </div>
        }

<!-- Sending To -->
        @if(sendingToVisible()) {
          <div class="sending-to ml-20 mr-20">
            <div class="sending-to-label">{{ deliveryMethod === 'manual' ? 'Your contact information' : 'Sending to' }}</div>

            <div class="sending-to-value" [ngClass]="{ 'sending-to-missing': sendingToMissing() }">
              <i class="me-2 align-middle" [ngClass]="deliveryMethod === 'sms' ? 'ri-smartphone-line' : 'ri-mail-line'"></i>{{ sendingToMissing() ? 'Not set' : sendingToValue() }}
            </div>

            <div class="sending-to-help" [ngClass]="{ 'sending-to-help-warning': sendingToMissing() }">{{ sendingToDescription() }}</div>
          </div>

<!-- Customise Message -->
          @if(customiseMessageVisible()) {
            <app-customise-message
              class="ml-20 mr-20"
              footerText="Saved to your company message template when you redeploy"
              idPrefix="customisemessage"
              [canEdit]="canEditCustomiseMessage"
              [defaultText]="customiseMessageResetText()"
              [(expanded)]="customiseMessageExpanded"
              [replacements]="customiseMessageReplacements"
              [title]="customiseMessageTitle"
              [(value)]="customiseMessageBody"
              (expandedChange)="onCustomiseMessageExpandedChange($event)"
            ></app-customise-message>
          }
        }

        @if(this.deliveryMethod == 'eid') {
          <div class="row">
            <div class="col-12 mb-3 ml-20 mr-20">
              <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                <!--
                <input type="radio" class="btn-check" name="invoiceDetails_billFormat" id="noneradio"
                       formControlName="invoiceDetails_billFormat" [value]="'none'">
                <label class="btn btn-outline-success mb-0" for="noneradio">None</label>
                -->
                <input type="radio" class="btn-check" name="eidRadio" id="eidexistingradio"
                       formControlName="eidRadio" [value]="'existing'" (change)="onRadioChange('existing')">
                <label class="btn btn-outline-success mb-0" for="eidexistingradio">&nbsp;&nbsp;&nbsp;Redeploy to existing device&nbsp;&nbsp;</label>
             
                <input type="radio" class="btn-check" name="eidRadio" id="eidreplacementradio"
                       formControlName="eidRadio" [value]="'replacement'" (change)="onRadioChange('replacement')">
                <label class="btn btn-outline-success mb-0" for="eidreplacementradio">&nbsp;&nbsp;Deploy to replacement device&nbsp;&nbsp;</label>
              </div>
            </div>
          </div>

          @if(eidRadioSelection != "") {
            <div class="row">
              <div class="col-12">
                <div class="mb-3 ml-20 mr-20">
                  <label for="eid-field" class="form-label text-right required">EID</label>
                  <input #eidfield
                    autocomplete="off"
                    class="form-control text-end"
                    [ngClass]="{ 'is-invalid': formData['eid'].errors }"
                    data-lpignore="true"
                    formControlName="eid"
                    id="eid-field"
                    placeholder=""
                    [readonly]="preventAutofill"
                    type="text"
                    (mousedown)="preventAutofill=false; ($any($event.target)).readOnly=false; ($any($event.target)).focus()"
                  />
                  @if(formData["eid"].hasError("minlength") || formData["eid"].hasError("maxlength")) {
                    <div class="invalid-feedback">EID must be 32 digits in length</div>
                  } @else if(formData["eid"].hasError("pattern")) {
                    <div class="invalid-feedback">EID must contain number characters only</div>
                  } @else if(formData["eid"].hasError("existingEidRequired")) {
                    <div class="invalid-feedback">When redploy is selected then EID must match the existing device</div>
                  } @else if(formData["eid"].hasError("newEidRequired")) {
                    <div class="invalid-feedback">When deploy is selected then EID must be changed to the new device</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
          }
        }

<!--RBW_20260707 - Only render the spinner row while redeploying so it doesn't leave an empty gap between sections (e.g. Sending to → Activation Details for Manual).-->
        @if(this.redeployInProgress) {
          <div class="row mb-4">
            <div class="col-12">
              <div class="hstack gap-2 justify-content-center">
                <lord-icon
                  colors="primary:#121331,secondary:#08a88a"
                  src="https://cdn.lordicon.com/kbtmbyzy.json"
                  style="width: 75px; height: 75px;"
                  trigger="loop"
                ></lord-icon>
              </div>
            </div>
          </div>
        }

<!-- Device-Specific Note -->
        <div *ngIf="deliveryMethod != '' && deliveryMethod !== 'manual' && !((deliveryMethod === 'sms' || deliveryMethod === 'email') && deviceType === '')"
          class="device-note ml-20 mr-20"
          [ngStyle]="{
            background: deviceType === 'ios'
              ? 'rgba(0,122,255,0.04)'
              : deviceType === 'android'
              ? 'rgba(61,220,132,0.04)'
              : 'rgba(0,120,212,0.04)',
            border: deviceType === 'ios'
              ? '1px solid rgba(0,122,255,0.12)'
              : deviceType === 'android'
              ? '1px solid rgba(61,220,132,0.12)'
              : '1px solid rgba(0,120,212,0.12)'
          }"
        >
          <div
            class="note-title"
            [ngClass]="{
              ios: deviceType === 'ios',
              android: deviceType === 'android',
              windows: deliveryMethod === 'email' || deliveryMethod === 'eid'
            }"
          >
            {{
              deviceType === 'ios'
                ? 'iOS Installation'
                : deviceType === 'android'
                ? 'Android Installation'
                : deliveryMethod === 'email' 
                ? 'Windows Installation'
                : 'EID Installation'
            }}
          </div>
      
          <div class="note-text">
            {{
              deviceType === 'ios'
                ? 'Link will open Settings → Cellular → Add eSIM automatically. Requires iOS 16+ and an eSIM-compatible iPhone (XS or later).'
                : deviceType === 'android'
                ? 'Link will trigger the native eSIM activation flow. Requires Android 10+ with eSIM support. Samsung devices use Samsung eSIM Manager.'
                : deliveryMethod === 'windows'
                ? 'Link will open Settings → Network & Internet → Cellular → Add eSIM. Requires Windows 11 with eSIM-capable hardware.'
                : 'eSIM will be pushed directly to the device via EID. No user action required.'
            }}
          </div>
        </div>

<!-- Manual Activation Details -->
        <div *ngIf="manualActivationDetailsVisible && deliveryMethod === 'manual'" class="manual-activation ml-20 mr-20">
          <div class="note-title ios">Activation Details</div>

          <div class="manual-activation-row">
            <span class="manual-activation-label">Activation Server</span>
            <span class="manual-activation-value">{{ manualActivationServer }}</span>
            <button type="button" class="btn btn-soft-success btn-sm" (click)="copyToClipboard(manualActivationServer)">Copy</button>
          </div>

          <div class="manual-activation-row">
            <span class="manual-activation-label">Activation Code</span>
            <span class="manual-activation-value">{{ manualActivationCode }}</span>
            <button type="button" class="btn btn-soft-success btn-sm" (click)="copyToClipboard(manualActivationCode)">Copy</button>
          </div>
        </div>

        <div class="labeled-divider mb-6 mt-3 ml-20 mr-20">
          <span class="divider-label"></span>
        </div>

        <div class="col-12">
          <div class="hstack gap-2 justify-content-end">
            @if(!embeddedFormMode) {
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm();modal.close('Close click')">Close</button>
            }
            <button type="submit" class="btn btn-success" id="add-btn" [disabled]="!isRedeployButtonEnabled()" (click)="saveFormData()">{{ getRedeployButtonText() }}</button>
          </div>
        </div>
      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>
</ng-template>

 
<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
